<div *ngIf="vatRate && auditNode?.responses[0]?.shippingMethod">
  <div class="header">
    <div class="invoice">{{ 'crossTherapy.document.billingSummary.articleDetails' | translate }}</div>
    <div class="sidebar"></div>
  </div>
  <div>
    <div *ngFor="let articleLine of this.auditNode?.responses[0]?.value">
      <itl-cross-therapy-billing-summary-line [articleLine]="articleLine"></itl-cross-therapy-billing-summary-line>
    </div>
    <div class="dash"></div>

    <div class="sub-total">
      <div class="label">{{ 'crossTherapy.document.billingSummary.subTotal' | translate }}:</div>
      <div class="sidebar">
        <div class="center">{{ subTotal }} €</div>
      </div>
    </div>
    <div class="summary">
      <div class="line">
        <div class="sub-header">{{'crossTherapy.document.billingSummary.summary' |translate}}</div>
        <div class="sidebar"></div>
      </div>

      <div class="line">
        <div class="charges">
          <itl-selection
            *ngIf="auditNode?.responses[0]?.shippingMethod"
            [title]="'crossTherapy.document.billingSummary.deliveryCharges'|translate"
            noIcon="true"
            noDeleteButton="true"
            [values]="shippingMethodSelectionItems"
            [(ngModel)]="auditNode.responses[0].shippingMethod"
            (change)="getSelectedShippingMethodCharges($event)"
          ></itl-selection>
          <div class="chargesInfo">{{ 'crossTherapy.document.billingSummary.deliveryChargesInfo' | translate }}</div>
        </div>
        <div class="sidebar">
          <div class="frame">
            <ion-input [(ngModel)]="auditNode.responses[0].deliveryCharges" (ionChange)="checkDeliveryCharges()">
            </ion-input>
            <div class="currency">€</div>
          </div>
        </div>
      </div>
      <div class="line">
        <div class="label">{{'crossTherapy.document.billingSummary.total' |translate}}</div>
        <div class="sidebar">
          <div class="center">{{netTotal}} €</div>
        </div>
      </div>
      <div class="line">
        <div *ngIf="vatRate">
          <div class="label">{{'crossTherapy.document.billingSummary.vatRate' |translate}}.: {{vatRate}}%</div>
        </div>
        <div class="sidebar">
          <div class="center">{{vatAmount}} €</div>
        </div>
      </div>
      <div class="solid-line"></div>
      <div class="line">
        <div class="label">{{'crossTherapy.document.billingSummary.grossTotal' |translate}}</div>
        <div class="sidebar"><div class="center total">{{grossTotalWithShipping}} €</div></div>
      </div>
    </div>
  </div>
</div>
